{
  "_meta": {
    "_comment": "merchant-v3 catalog namespace VI (primary). CatalogSidebar left rail + Task 35 copack browse.",
    "locale": "vi",
    "completeness": "primary",
    "vg-binding": "P14.1.D-15,P14.1.D-16"
  },
  "sidebar": {
    "categories": "Danh mục",
    "filters": "Bộ lọc",
    "priceRange": "Khoảng giá",
    "min": "Tối thiểu",
    "max": "Tối đa"
  },
  "copack": {
    "page": {
      "title": "Nhóm vận chuyển gom kiện",
      "subtitle": "Duyệt các nhóm vận chuyển hợp nhất để tối ưu chi phí giao hàng."
    },
    "filter": {
      "label": "Lọc theo blueprint",
      "placeholder": "Mã blueprint",
      "apply": "Áp dụng",
      "clear": "Xóa lọc"
    },
    "table": {
      "groupKey": "Nhóm",
      "location": "Nơi sản xuất",
      "packingClass": "Loại đóng gói",
      "blueprints": "Blueprint",
      "shipping": "Phí ship mẫu",
      "additional": "Phí kiện thêm"
    },
    "blueprintsCount_one": "{{count}} blueprint",
    "blueprintsCount_other": "{{count}} blueprint",
    "state": {
      "loading": "Đang tải nhóm gom kiện…",
      "empty": {
        "title": "Chưa có nhóm gom kiện",
        "body": "Không có nhóm vận chuyển hợp nhất nào khớp bộ lọc."
      },
      "error": "Không tải được nhóm gom kiện.",
      "retry": "Thử lại"
    },
    "pagination": {
      "page": "Trang {{page}} / {{pages}}",
      "prev": "Trước",
      "next": "Sau"
    }
  }
}
